export default "__VITE_ASSET__D6q1QR88__"